import type { ConstValues } from './helpers.ts';
import type { BaseRow } from './tableHelpers.ts';

export const SelectOperation = {
  SELECT: 'select',
  UNSELECT: 'unselect',
} as const;
export type SelectOperation = ConstValues<typeof SelectOperation>;

export type ToggleSelect<RowT extends BaseRow> = (items: RowT[], operation: SelectOperation) => void;

export interface SelectListProps<RowT extends BaseRow> {
  selectedItems: RowT[];
  disabledItems?: RowT[];
  toggleSelect: ToggleSelect<RowT>;
  onToggleAll?: () => void;
}

export interface SelectableTableProps<RowT extends BaseRow> extends SelectListProps<RowT> {}
